import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../service/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Loader2, Mail } from 'lucide-react';
import '../css/style.css';
import '../css/Login.css';

function RecuperarSenha() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const navigate = useNavigate();

    // Limpa o erro ao editar o e-mail.
    useEffect(() => {
        setErrorMessage('');
    }, [email]);

    const handleEnviar = async () => {
        if (!email) {
            setErrorMessage('Digite seu e-mail para recuperar a senha.');
            return;
        }

        setLoading(true);
        setErrorMessage('');
        try {
            // O Firebase envia o e-mail e hospeda a tela de definição da nova senha.
            await sendPasswordResetEmail(auth, email);
            setSuccessMessage(
                'Se este e-mail estiver cadastrado, enviamos um link para redefinir a senha. Verifique sua caixa de entrada e a pasta de spam.'
            );
        } catch (error) {
            switch (error.code) {
                case 'auth/invalid-email':
                    setErrorMessage('E-mail inválido.');
                    break;
                case 'auth/user-not-found':
                    setErrorMessage('Não encontramos uma conta com este e-mail.');
                    break;
                case 'auth/too-many-requests':
                    setErrorMessage('Muitas tentativas. Tente novamente em alguns minutos.');
                    break;
                default:
                    setErrorMessage('Erro ao enviar o e-mail. Tente novamente.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-content">
                <div className="login-block">
                    {/* Espaço reservado para a logo PersonalMetrics */}
                    <div className="login-topo-espaco"></div>

                    <div className="login-form-area">
                        <h1>Recuperar senha</h1>
                        <h3>Digite seu e-mail para receber o link de redefinição de senha.</h3>

                        {!successMessage && (
                            <div className="form-login">
                                <label htmlFor="user">E-mail</label>
                                <div className="login-campo">
                                    <span className="login-campo-icone"><Mail size={18} /></span>
                                    <input
                                        className="inputs-login"
                                        id="user"
                                        type="email"
                                        placeholder="seu@email.com"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onKeyDown={(e) => e.key === 'Enter' && handleEnviar()}
                                    />
                                </div>

                                <div className="login-opcoes"></div>

                                <button
                                    onClick={handleEnviar}
                                    className="login-button"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <span className="loader-content">
                                            <Loader2 className="animate-spin" size={18} /> Enviando...
                                        </span>
                                    ) : (
                                        'Enviar link de redefinição'
                                    )}
                                </button>
                            </div>
                        )}

                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                        {successMessage && <p className="success-message">{successMessage}</p>}

                        <span className="forgot-span">
                            <a className="login-recuperar" onClick={() => navigate('/')}>
                                Voltar para o login
                            </a>
                        </span>
                    </div>

                    <div className="login-rodape">
                        <span className="login-rodape-linha"></span>
                        <div className="login-rodape-texto">
                            <p className="login-rodape-titulo">DADOS . ANÁLISE . PRESCRIÇÃO . RESULTADOS .</p>
                            <p className="login-rodape-sub">A TECNOLOGIA QUE TRANSFORMA PROFISSIONAIS EM REFERÊNCIA.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecuperarSenha;
